import {
  CustomEvent,
  CustomEventsResponse as Response,
  UpdateCustomEventParams,
  convertCustomEvent,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'

import { useRecentStoresContext } from 'stores/context'
import keys from './shared/keys'

type Variables = UpdateCustomEventParams

export function useAddCustomEvent() {
  const { server } = useServer()
  const client = useQueryClient()
  const { activeStoreId } = useRecentStoresContext()

  return useMutation({
    mutationFn: addCustomEvent,
    onSuccess: async () => {
      client.invalidateQueries({ queryKey: keys.all }).catch(e => null)
    },
  })

  async function addCustomEvent(updateParams: Variables): Promise<CustomEvent> {
    const queryParams = updateParams.storeIds
      ? `?store_ids=${updateParams.storeIds.join(',')}`
      : `?store_ids=${activeStoreId}`

    const response = await server.post<Response.CustomEvent>(
      `/v2/events/custom/stores${queryParams}`,
      {
        summary: updateParams.summary,
        description: updateParams.description,
        start_date: updateParams.startDate,
        end_date: updateParams.endDate,
        recurring: updateParams.recurring,
        frequency: updateParams.frequency,
        deleted: updateParams.deleted,
        event_type: updateParams.eventType,
        visible_to_roles: updateParams.visibleToRoles,
        all_day: updateParams.allDay,
        block_rto: updateParams.blockRto,
      }
    )

    return convertCustomEvent(response)
  }
}
